<h1 class="hero-tite" [style.font-size]="titleSize">{{ title | translate }}</h1>

<p
  [ngClass]="{ 'fw-bold': isSubtitleBold }"
  class="fs-5"
  *ngIf="subtitle" [style.font-size]="subtitleSize">
  {{ subtitle | translate }}
</p>

<button
  class="btn btn-hero fw-bold mt-3"
  (click)="showAkkyProModal = true"
>
  {{ buttonText | translate }}
</button>

<!----------------------------------- Delete modal  ----------------------------------->
<app-dialog
  [preventCloseFromBackDrop]="true"
  [enableCloseDialogButton]="true"
  [show]="showAkkyProModal"
  [title]="title"
  (showChange)="showAkkyProModal = $event"
  [altIconClose]="true"
>
  <div class="w-100">
    <iframe
      *ngIf="safeUrl"
      [src]="safeUrl"
      width="400"
      height="725"
      frameborder="0"
    >
    </iframe>
    <p *ngIf="!safeUrl">Cargando contenido...</p>
  </div>
</app-dialog>
